<div class="login-container">
  <div class="login-card">
    <div class="logo-container">
      <img [src]="logoPath" [alt]="appTitle + ' logo'" />
    </div>

    @if (showTotpStep) {
      <div class="totp-step">
        <h2 translate>views.login.totp_title</h2>
        <p class="text-muted" translate>views.login.totp_description</p>

        <div class="form-group">
          <div class="input-wrapper">
            <svg cIcon name="cilLockLocked" class="input-icon"></svg>
            <input
              type="text"
              inputmode="numeric"
              pattern="[0-9]{6}"
              maxlength="6"
              autocomplete="one-time-code"
              aria-label="Code d'authentification à 6 chiffres"
              [(ngModel)]="totpCode"
              [ngModelOptions]="{ standalone: true }"
              placeholder="000000"
              (keyup.enter)="submitTotpCode()"
            />
          </div>
        </div>

        <button
          class="btn-primary"
          type="button"
          [disabled]="totpLoading || totpCode.length !== 6"
          (click)="submitTotpCode()"
        >
          @if (totpLoading) {
            <output class="spinner-border spinner-border-sm" aria-live="polite">
              <span class="visually-hidden">Loading...</span>
            </output>
          } @else {
            <span translate>views.login.totp_verify</span>
          }
        </button>

        <div class="actions-row">
          <button
            type="button"
            class="btn-link"
            (click)="cancelTotp()"
            translate
          >
            views.login.totp_cancel
          </button>
        </div>
      </div>
    } @else {
      <form [formGroup]="connectForm" (ngSubmit)="onSubmitConnect()">
        <div class="form-group">
          <div class="input-wrapper">
            <label for="adminEmail" class="visually-hidden">Username</label>
            <svg cIcon name="cilUser" class="input-icon"></svg>
            <input
              id="adminEmail"
              name="username"
              autocomplete="username"
              type="email"
              [placeholder]="'form.email' | translate"
              formControlName="email"
            />
          </div>
          @if (
            connectForm.get('email')?.invalid &&
            connectForm.get('email')?.touched
          ) {
            <div class="validation-errors">
              @if (connectForm.get('email')?.errors?.['required']) {
                <small class="text-danger" translate
                  >errors.email_required</small
                >
              }
              @if (connectForm.get('email')?.errors?.['invalidEmail']) {
                <small class="text-danger" translate
                  >errors.email_invalid</small
                >
              }
              @if (connectForm.get('email')?.errors?.['xssDetected']) {
                <small class="text-danger" translate>errors.xss_detected</small>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <div class="input-wrapper">
            <label for="adminPassword" class="visually-hidden">Password</label>
            <svg cIcon name="cilLockLocked" class="input-icon"></svg>
            <input
              id="adminPassword"
              name="password"
              autocomplete="current-password"
              type="password"
              [type]="passwordVisible ? 'text' : 'password'"
              [placeholder]="'form.password' | translate"
              formControlName="password"
            />
            <button
              type="button"
              class="btn-toggle-password"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="
                passwordVisible ? 'Hide password' : 'Show password'
              "
            >
              <svg
                cIcon
                [name]="passwordVisible ? 'cilMoon' : 'cilSun'"
                size="sm"
              ></svg>
            </button>
          </div>
          @if (
            connectForm.get('password')?.invalid &&
            connectForm.get('password')?.touched
          ) {
            <div class="validation-errors">
              @if (connectForm.get('password')?.errors?.['required']) {
                <small class="text-danger" translate
                  >errors.password_required</small
                >
              }
              @if (connectForm.get('password')?.errors?.['minlength']) {
                <small class="text-danger" translate
                  >errors.password_min_length</small
                >
              }
            </div>
          }
        </div>

        <div class="checkbox-wrapper">
          <input
            id="keepConnection"
            type="checkbox"
            formControlName="keepConnection"
          />
          <label for="keepConnection" translate>
            views.login.stay_connected
          </label>
        </div>

        <button
          class="btn-primary"
          type="submit"
          [disabled]="loading || connectForm.invalid"
        >
          @if (loading) {
            <output class="spinner-border spinner-border-sm" aria-live="polite">
              <span class="visually-hidden">Loading...</span>
            </output>
          } @else {
            <span translate>views.login.connect</span>
          }
        </button>

        <div class="actions-row">
          <button
            type="button"
            class="btn-link"
            [routerLink]="['/forgot-password']"
            translate
          >
            views.login.forgot_password
          </button>
        </div>
      </form>
    }
  </div>
</div>
